// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"31b29aa2","416":"0b380277","538":"7502cfce","566":"d3034414","614":"084c75c7","676":"d025181e","769":"ef9be1e7"}[chunkId] + ".chunk.js";
};